import { api } from '@/lib/api/client';
import type { NotificationsResponse } from '../types';

// Query keys for notifications
export const notificationKeys = {
  all: ['notifications'] as const,
  list: () => [...notificationKeys.all, 'list'] as const,
  count: () => [...notificationKeys.all, 'count'] as const,
};

// Notifications API functions
export const notificationsApi = {
  // Get a page of notifications (the bell dropdown infinite-scrolls)
  getAll: async (offset = 0, limit = 20): Promise<NotificationsResponse> => {
    return api.get<NotificationsResponse>('/notification', {
      params: { offset, limit },
    });
  },

  // Get unread count
  getCount: async (): Promise<number> => {
    return api.get<number>('/notification/new/count');
  },

  // Mark notification as read
  markAsRead: async (id: string | number): Promise<void> => {
    await api.patch(`/notification/${id}/read`);
  },

  // Mark all of the current user's notifications as read
  markAllAsRead: async (): Promise<void> => {
    await api.patch('/notification/read-all');
  },

  // Delete notification
  delete: async (id: string | number): Promise<void> => {
    await api.delete(`/notification/${id}`);
  },
};
